import { createFetchClient } from "@devowl-wp/api";
import { RootStore } from "../store/stores.js";
let client;
/**
 * Strongly-typed RPC client for the Real Commerce API. Path and method are derived from
 * the contract types (`Routes` from `@devowl-wp/api-real-commerce`); consumers call
 * routes via `client.checkout.cartAbandonmentEmailBlacklist.post({ request: { ... } })`
 * without re-declaring path / method anywhere on the consumer side.
 *
 * Browser-safe: `createFetchClient` only depends on `@devowl-wp/api`'s contract types
 * (`import type`), never invokes `createContract*()`, and therefore does not pull
 * `node:async_hooks` into the bundle.
 */ function getRealCommerceContractClient() {
    if (!client) {
        const restRoot = RootStore.get.optionStore.others.realCommerceRestRoot ?? "";
        const { lang } = document.documentElement;
        client = createFetchClient({
            baseUrl: restRoot,
            version: "1.0.0",
            headers: {
                ...lang ? {
                    "Accept-Language": lang
                } : {}
            }
        });
    }
    return client;
}
export { getRealCommerceContractClient };
